import {BotType, ConvoStarterVisibility, WidgetSettings} from "../../../../../../../api/generated";
import {SelectOption} from "../../../../../../elements/select/SelectDropdown";
import {WidgetAppearanceLocaleVariantUI} from "../../widgetAppearanceUpdateSlice";

export type PreviewView = "open" | "splash" | "fab-initial" | "fab-intro" | "fab-persistent";

export const PREVIEW_VIEW_OPTIONS: SelectOption<PreviewView>[] = [
    {label: "Chat", value: "open"},
    {label: "Splash", value: "splash"},
    {label: "Floating buttons", value: "fab-initial"},
    {label: "Intro", value: "fab-intro"},
    {label: "Got a question?", value: "fab-persistent"}
];

export interface PreviewMessage {
    type: "preview";
    settings: WidgetSettings;
    view: PreviewView;
    isMobile: boolean;
}

const startersFor = (variant: WidgetAppearanceLocaleVariantUI, visibility: ConvoStarterVisibility): string[] =>
    (variant.convoStarters || [])
        .filter(starter => starter.visibility === visibility)
        .map(starter => starter.message)
        .filter(message => message.trim() !== "");

export const toPreviewSettings = (variant: WidgetAppearanceLocaleVariantUI, botType: BotType): WidgetSettings => ({
    name: variant.assistantName,
    botType,
    showWidget: true,
    locale: variant.locale,
    widgetAppearanceSetting: {
        mainColour: variant.brandColour,
        widgetPosition: variant.widgetPosition,
        horizontalOffsetPx: variant.horizontalOffsetPx,
        verticalOffsetPx: variant.verticalOffsetPx,
        hidePoweredBy: variant.hidePoweredBy,
        promptPopUpView: variant.promptPopUpView,
        popUpDelaySec: variant.popUpDelaySec,
        showFooterMessage: variant.showFooterMessage,
        footerMessage: variant.footerMessage,
        showTerms: variant.showTerms,
        termsTitle: variant.termsTitle,
        termsUrl: variant.termsUrl,
        initialBotMessage: variant.initialBotMessage,
        bubbleConvoStarters: startersFor(variant, ConvoStarterVisibility.Bubble),
        chatConvoStarters: startersFor(variant, ConvoStarterVisibility.Chat),
        vehicleDetailsButtons: variant.vehicleDetailsButtons,
        enablePersonalizedVehicleDescription: variant.enablePersonalizedVehicleDescription,
        gtmAnalyticsEnabled: false,
        assistantName: variant.assistantName
    },
    surveySettings: {
        afterMessagesEnabled: false,
        afterMessagesCount: 8,
        afterBookingEnabled: false
    }
});

export const buildPreviewMessage = (variant: WidgetAppearanceLocaleVariantUI,
                                    botType: BotType,
                                    view: PreviewView,
                                    isMobile: boolean): PreviewMessage => ({
    type: "preview",
    settings: toPreviewSettings(variant, botType),
    view,
    isMobile
});

export const previewUrl = (widgetBaseUrl: string): string => `${widgetBaseUrl.replace(/\/+$/, "")}/?preview=true`;

export const isWidgetInitRequest = (data: unknown): boolean =>
    (data as { type?: unknown } | null)?.type === "widget-init-request";
